module.exports = __webpack_public_path__ + "media/Tina.cd776e38.mp3";